/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_RepsInputs */

const en_us2_workout_reps = /** @type {(inputs: Workout_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reps`)
};

const pt_br2_workout_reps = /** @type {(inputs: Workout_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetições`)
};

const es_419_workout_reps = /** @type {(inputs: Workout_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reps`)
};

const pt_pt2_workout_reps = /** @type {(inputs: Workout_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetições`)
};

const fr_fr2_workout_reps = /** @type {(inputs: Workout_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répétitions`)
};

const de_de2_workout_reps = /** @type {(inputs: Workout_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wdh.`)
};

const it_it2_workout_reps = /** @type {(inputs: Workout_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ripetizioni`)
};

/**
* | output |
* | --- |
* | "Reps" |
*
* @param {Workout_RepsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_reps = /** @type {((inputs?: Workout_RepsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_RepsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_reps(inputs)
	if (locale === "es-419") return es_419_workout_reps(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_reps(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_reps(inputs)
	if (locale === "de-DE") return de_de2_workout_reps(inputs)
	if (locale === "it-IT") return it_it2_workout_reps(inputs)
	return en_us2_workout_reps(inputs)
});
export { workout_reps as "workout.reps" }